import { FileEdit, Calendar, Users, UsersRound } from "lucide-react"
import { registerKpi, type KpiData } from "./kpi-registry"
import { getTasks } from "services/tasks"
import { getAppointments } from "services/appointments"
import { getContacts } from "services/contacts"
import { getUsersStatus } from "services/users"

const ALERT_RED = "#f87171"
const ONLINE_GREEN = "#4ade80"

registerKpi({
  id: "tasks",
  label: "Task",
  icon: FileEdit,
  linkTo: "/tasks",
  colorAccent: "#7b3fff",
  order: 1,
  fetchData: async (): Promise<KpiData> => {
    try {
      const res = await getTasks()
      const list = Array.isArray(res?.data) ? res.data : []
      const open = list.filter((t: any) => t?.is_completed !== true)
      const overdue = open.filter((t: any) => t?.is_overdue === true).length
      return {
        value: open.length,
        subtitle: overdue > 0 ? `${overdue} scadute` : undefined,
        subtitleColor: overdue > 0 ? ALERT_RED : undefined,
      }
    } catch {
      return { value: 0 }
    }
  },
})

function getCurrentWeekRange(): { start: Date; end: Date } {
  const now = new Date()
  const day = now.getDay() // 0 = sun .. 6 = sat
  const diffToMonday = day === 0 ? -6 : 1 - day
  const start = new Date(now)
  start.setDate(now.getDate() + diffToMonday)
  start.setHours(0, 0, 0, 0)
  const end = new Date(start)
  end.setDate(start.getDate() + 7)
  return { start, end }
}

registerKpi({
  id: "agenda",
  label: "Agenda",
  icon: Calendar,
  linkTo: "/agenda",
  colorAccent: "#38bdf8",
  order: 2,
  fetchData: async (): Promise<KpiData> => {
    try {
      const res = await getAppointments()
      const raw = Array.isArray(res?.data) ? res.data : (res?.data?.results ?? [])
      const list: any[] = Array.isArray(raw) ? raw : []
      const { start, end } = getCurrentWeekRange()
      const startMs = start.getTime()
      const endMs = end.getTime()
      const inWeek = list.filter((a: any) => {
        if (!a?.date) return false
        const d = new Date(`${a.date}T00:00:00`)
        const t = d.getTime()
        return !Number.isNaN(t) && t >= startMs && t < endMs
      })
      return { value: inWeek.length, subtitle: "questa settimana" }
    } catch {
      return { value: 0 }
    }
  },
})

registerKpi({
  id: "contacts",
  label: "Contatti",
  icon: Users,
  linkTo: "/contacts",
  colorAccent: "#4ade80",
  order: 3,
  fetchData: async (): Promise<KpiData> => {
    try {
      const res = await getContacts()
      const list = Array.isArray(res?.data) ? res.data : []
      const weekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000
      const newThisWeek = list.filter((c: any) => {
        const created = c?.created_at || c?.created || c?.date_joined
        if (!created) return false
        const t = new Date(created).getTime()
        return !Number.isNaN(t) && t >= weekAgo
      }).length
      return {
        value: list.length,
        subtitle: newThisWeek > 0 ? `${newThisWeek} nuovi questa sett.` : undefined,
      }
    } catch {
      return { value: 0 }
    }
  },
})

registerKpi({
  id: "team",
  label: "Team",
  icon: UsersRound,
  linkTo: "/team",
  colorAccent: "#f59e0b",
  order: 4,
  fetchData: async (): Promise<KpiData> => {
    try {
      const res = await getUsersStatus()
      const list = Array.isArray(res?.data) ? res.data : []
      const online = list.filter(
        (u: any) => u?.is_online === true || u?.online === true || u?.is_active === true
      ).length
      return {
        value: list.length,
        subtitle: `${online} online`,
        subtitleColor: ONLINE_GREEN,
      }
    } catch {
      return { value: 0 }
    }
  },
})